import _ from 'lodash';
import { apiSearch, apiFetch, apiRemove } from '../utility';

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : 'supplier',
			dispatch,
			callback,
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'supplier.get',
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'supplier.add',
			listNameToUpdate : 'supplierIds',
			params,
			dispatch,
			successMessage : `Supplier created successfully. 
				Click continue to return to the supplier page.`,
			onSuccessRedirectTo : '/logistics/suppliers',
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'supplier.update',
			params,
			dispatch,
			successMessage : `Supplier updated successfully. 
				Click continue to return to the supplier page.`,
			onSuccessRedirectTo : '/logistics/suppliers',
			callback,
		});
	};
};

export const remove = ({supplierId, callback = _.noop}) => {
	return dispatch => {
		apiRemove({
			base : 'supplier',
			id : supplierId,
			dispatch,
			callback,
		});
	};
};
